exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.footnote[data-v-338b62c9]{color:inherit;font-weight:400}sup[data-v-338b62c9]{vertical-align:super;font-size:x-small}", ""]);

// exports
